<template>
  <v-container fluid grid-list-xl>
    <v-card raised>
        <v-card-title class="display-1">
          Location Monthly Reports
        </v-card-title>

      <data-filter
        :loading="loading"
        :selectables="selectables"
        :filters="filters"
        :hasActionButton="false"
        @updateFilters="updateFilters"
      ></data-filter>
    </v-card>

    <monthly-report
      v-if="report"
      :report="report"
    ></monthly-report>
  </v-container>
</template>

<script>
  import MonthlyReport from '@/components/Rental/MonthlyReports/MonthlyReport'
  import locationService from '@/services/rental/location'
  import DataFilter from '@/components/Common/DataFilter'
  import moment from 'moment-timezone'
  import _ from 'lodash'

  export default {
    components: {
      MonthlyReport,
      DataFilter
    },
    data () {
      return {
        loading: false,
        report: null,
        locations: [],
        selectables: {
          locations: [],
          periods: [],
        },
        filterValues: {},
        filters: {
          location_id: {
            items: 'locations',
            text: 'Location',
            value: null,
            clearable: false,
          },
          period: {
            items: 'periods',
            text: 'Period',
            value: null,
            clearable: false,
          },
        },
      }
    },
    created () {
      this.getLocations()
    },
    methods: {
      async getLocations () {
        this.loading = true
        const { data } = await locationService.getAll(false, ['locationClientReports'])
        this.locations = data.data
        this.selectables['locations'] = this.locations.map((location) => {
          return {
            text: location.name,
            value: location.id,
            align: 'left',
          }
        })
        this.loading = false
      },
      updateFilters (filters) {
        this.filterValues = filters
        this.selectables['periods'] = []
        if (filters.location_id) {
          let location = this.locations.find(location => location.id === filters.location_id)
          if (location.location_client_reports) {
            this.selectables['periods'] = location.location_client_reports.map((report) => {
              return {
                text: moment(report.period, 'YYYYMM').format('MMM YYYY'),
                value: report.id,
                align: 'left'
              }
            })
          }
        }
        if (filters.period) {
          this.showReport()
        }
      },
      showReport () {
        let location = this.locations.find(location => location.id === this.filterValues.location_id)
        let report = location.location_client_reports.find(report => report.id === this.filterValues.period)
        let periodStartName = moment.unix(report.period_start).format('MM/DD/YYYY')
        let periodEndName = moment.unix(report.period_end).format('MM/DD/YYYY')

        let totalCostAndExpense = _.round(+report.cost_product + +report.cost_rent + (+report.cost_replenishment || 0) + +report.cost_transaction + +report.cost_internet, 2)
        let totalRevenue = _.round(+report.income_sales, 2)
        let adjustmentTotal = _.round(+report.adjustment_total, 2)
        let profit = _.round(totalRevenue - totalCostAndExpense + adjustmentTotal, 2)

        report = location.location_client_reports.find(report => report.id === this.filterValues.period)
        report.location = location

        this.report = {
          locationName: location.name,
          locationAddress: location.address,
          periodStartName,
          periodEndName,
          content: [
            // Revenue
            {
              topic: {
                header: 'Revenue'
              },
              entries: [
                {
                  header: 'Merchandise Sales',
                  value: report.income_sales,
                  show: report.income_sales
                },
                {
                  header: 'Sales Promotion Services, Slotting Services & Other Revenue',
                  value: report.income_other,
                  show: report.income_other > 0
                },
                {
                  header: 'Total Revenue (A)',
                  value: totalRevenue,
                  type: 'subtotal'
                }
              ]
            },
            // Cost & Expenses
            {
              topic: {
                header: 'Cost & Expenses'
              },
              entries: [
                {
                  header: 'Cost of Goods Sold',
                  value: report.cost_product
                },
                {
                  header: 'Operation Cost',
                  value: report.cost_replenishment
                },
                {
                  header: 'Rent',
                  hint: report.rent_clause,
                  value: report.cost_rent
                },
                {
                  header: 'Transaction Fee',
                  hint: '0.5% - 5% of Merchandise Sales',
                  value: report.cost_transaction
                },
                {
                  header: 'Internet Fee',
                  value: report.cost_internet
                },
                {
                  header: 'Technology Cost',
                  hint: 'Development & maintenance of vending machine management platform and point-of-sale system',
                  value: 'Waived'
                },
                {
                  header: 'Vending Machine Management Cost',
                  value: 'Waived'
                },
                {
                  header: 'Franchisee Share',
                  value: 'Not applicable'
                },
                {
                  header: 'Total Cost & Expenses (B)',
                  value: totalCostAndExpense,
                  type: 'subtotal'
                }
              ]
            },
            // Adjustment
            {
              topic: {
                header: 'Adjustment'
              },
              entries: [
                {
                  header: 'Adjustment (C)',
                  value: report.adjustment_total,
                  hint: report.adjustment_total_remark,
                  type: 'subtotal'
                },
              ]
            },
            // Net Profit
            {
              topic: {
                header: 'Net Profit (A - B + C)',
                value: profit,
                type: 'subtotal'
              }
            },
          ]
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Rental/MonthlyReports/Overview.vue